import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';
import Header from './components/Header';
import Login from './pages/Login';
import Signup from './pages/Signup';
import MarketNews from './pages/MarketNews';
import WatchlistBrief from './pages/WatchlistBrief';

/**
 * Top-level routing.
 *
 * Public routes: /login, /signup
 * Protected: /market-news, /watchlist-brief
 * Anything else → redirect to /market-news (which itself redirects to /login if not authed).
 *
 * The Header is rendered globally but renders nothing when there's no user (handled
 * inside the component) — keeps the auth pages clean without a layout switch here.
 */
export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Header />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/market-news" element={
            <ProtectedRoute><MarketNews /></ProtectedRoute>
          } />
          <Route path="/watchlist-brief" element={
            <ProtectedRoute><WatchlistBrief /></ProtectedRoute>
          } />
          <Route path="/" element={<Navigate to="/market-news" replace />} />
          <Route path="*" element={<Navigate to="/market-news" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
